<template>
  <div class="structure">

    <el-row justify="center" class="structure-title mt-5">
      <el-col align="center">
        <div v-html="data.call"></div>
      </el-col>
    </el-row>

    <div
      class="graph mt-5"
      :class="{'section': !selectedSection}"
    >
      <div
        v-for="buble in data.bubles"
        :class="`bubble bubble-bottom-left bubble-${buble.order}`"
        :key="buble.order"
        @click="openSection(buble.order, $el)"
      >
        <div class="bubble-content">
          <div class="image">
            <figure>
              <img
                class="icon"
                alt="Vue logo"
                :src="buble.avatar"
              />
            </figure>
          </div>
          <div class="description">
            <h4>{{ buble.name }}</h4>
            <p>{{ buble.role }}</p>
          </div>
        </div>
      </div>
    </div>

    <el-row justify="center" class="mb-5">
      <el-col :span="20" align="center">
        <div class="education-call mb-5">
          <button
              class="btn-login btn-position btn-change-color"
              type="primary"
              round
            >
            <a href="https://pixeon365.sharepoint.com/:x:/s/TecnologiadaInformao/EU2lVudvFN1Cm5t9JNU9e9oBFCdORPMTq898RhOd-Glp7A?e=F8M870" target="blank">
              Lista de e-mail corporativo
            </a>
            </button>
        </div>
      </el-col>
    </el-row>

    <el-dialog v-model="dialogVisible" width="70%" top="50px" class="dialogSection">
      <component v-if="selectedSection" :is="selectedSection" :data="data"></component>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { ref, onBeforeMount } from 'vue'
import { firebaseRoutes } from '../../config/firebase.conf'

import Section1 from './section1/Section01.vue'
import Section2 from './section2/Section2.vue'
import Section3 from './section3/Section3.vue'
import Section4 from './section4/Section4.vue'
import Section5 from './section5/Section5.vue'
import Section6 from './section6/Section6.vue'
// import Section7 from './section7/Section7.vue'
import Section8 from './section8/Section8.vue'
export default {
  name: 'Structure',
  components: {
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    Section6,
    // Section7,
    Section8
  },
  setup () {
    const dialogVisible = ref(false)
    const data = ref({})

    onBeforeMount(async () => {
      data.value = await axios.get(firebaseRoutes.estrutura).then((response) => {
        const result = []
        for (const id in response.data) {
          result.push({
            id: id,
            call: response.data[id].call,
            bubles: [
              response.data[id].buble1,
              // response.data[id].buble2,
              response.data[id].buble3,
              response.data[id].buble4,
              response.data[id].buble5,
              response.data[id].buble6,
              // response.data[id].buble7,
              response.data[id].buble8
            ]
          })
        }
        return result[0]
      })
    })

    const selectedSection = ref('')
    const openSection = (value, el) => {
      dialogVisible.value = true
      selectedSection.value = `Section${value}`
    }

    return {
      data,
      selectedSection,
      openSection,
      dialogVisible
    }
  }
}
</script>

<style lang="scss" >
@import "~@/styles/variables.scss";
.structure{
  .structure-title {
  margin-left: auto;
  margin-right: auto;
  width: 40%;

  h3 {
    text-transform: uppercase;
    color: $green;
    font-size: 3rem;
  }

  p {
    font-size: 2rem;
    font-weight: bold;
  }
}

.graph {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  width: 100rem;
  height: 70rem;
  background-image: url("../../assets/images/structure/orgfundo02.png");
  background-size: 40rem 40rem;
  background-repeat: no-repeat;
  background-position: center;
}

.bubble {
  cursor: pointer;
  position: relative;
  width: 230px;
  min-width: 230px;
  max-width: 230px;
  border-radius: 8rem;
  padding: 14px;
  padding-bottom: 10px;
}

.bubble:hover {
  transform: translateY(-3px);
  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.4);
}
.btn:hover::after {
  transform: scaleX(1.4) scaleY(1.6);
  opacity: 0;
}

.bubble-bottom-left:before {
  content: "";
  position: absolute;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
}

.bubble-content {
  display: flex;
  .image {
    width: 7rem;
    min-width: 7rem;
    height: 7rem;
    background: transparent;
    border-radius: 5rem;
    flex-grow: 1;
    img {
      width: 100%;
    }
  }
  .description {
    text-align: left;
    padding-left: 2rem;
    padding-right: 2rem;
    color: $white;
    width: 135px;
    h4 {
      font-size: 1.6rem;
      text-transform: uppercase;
      line-height: 1.8rem;
    }

    p {
      line-height: 1.8rem;
      font-size: 1.2rem;
    }
  }
}

.bubble-1 {
  background: $light-blue;
  left: 36.8rem;
  top: 1rem;
}

.bubble-1:before {
  bottom: -20px;
  border-top: 20px solid $light-blue;
  left: 11rem;
}

.bubble-2 {
  background: $light-blue;
  left: 7rem;
  top: 3rem;
}

.bubble-2:before {
  bottom: 6px;
  border-top: 20px solid $light-blue;
  transform: rotate(315deg);
  left: 20rem;
}

.bubble-3 {
  background: $light-blue;
  left: 71rem;
  top: 6rem;
}

.bubble-3:before {
  bottom: 6px;
  border-top: 20px solid $light-blue;
  left: -0.8rem;
  transform: rotate(45deg);
}

.bubble-4 {
  background: $purple;
  left: 72rem;
  top: 21rem;
}

.bubble-4:before {
  bottom: 65px;
  border-top: 20px solid $purple;
  left: -1.5rem;
  transform: rotate(120deg);
}

.bubble-5 {
  background: $light-blue;
  left: 5rem;
  top: -13rem;
}

.bubble-5:before {
  bottom: 3px;
  border-top: 20px solid $light-blue;
  left: 20rem;
  transform: rotate(310deg);
}

.bubble-6 {
  width: 114px;
  background: $purple;
  left: 6rem;
  top: 2rem;
}

.bubble-6:before {
  bottom: 70px;
  border-top: 20px solid $purple;
  left: 20rem;
  transform: rotate(230deg);
}

.bubble-7 {
  background: $blue;
  left: 36.8rem;
  top: 0rem;
}

.bubble-7:before {
  bottom: 87px;
  border-top: 20px solid $blue;
  left: 11rem;
  transform: rotate(180deg);
}

.bubble-8 {
  background: $blue;
  left: 38rem;
  top: 9rem;
}

.bubble-8:before {
  bottom: 90px;
  border-top: 20px solid $blue;
  left: 10rem;
  transform: rotate(180deg);
}

.section {

}

.fade-enter-active, .fade-leave-active {
  transition: display .5s;
}

.fade-enter, .fade-leave-to {
  display: none;
}

.dialogSection {
  img{
    width: 100%
  }
}
}

</style>
